import { Sort, SortOrder } from '../grid/experimental.grid';

import { FocusSelectorMetricModel } from './focus-selector-metric.model';
import { Context, FocusSelectorGrid } from './focus-selector.grid.model';

export enum ColumnID {
    METRIC = 'metric',
    OA = 'oa',
    ON_SCORECARD = 'on_scorecard',
    ACTUAL = 'actual',
    TARGET = 'target',
    PERCENT_TO_TARGET = 'percent_to_target',
    SUPERGROUP_PERCENT_TO_TARGET = 'supergroup_percent_to_target',
}

export interface RowContext extends Context {
    metric: FocusSelectorMetricModel;
}

export interface CellContext
    extends Context,
        Partial<FocusSelectorMetricModel> {
    checked?: boolean;
}

export interface MetricGrid
    extends FocusSelectorGrid<RowContext, CellContext> {}

export const defaultSortDefs: Sort[] = [
    {
        columnId: ColumnID.OA,
        order: SortOrder.ASC,
    },
    {
        columnId: ColumnID.ON_SCORECARD,
        order: SortOrder.DESC,
    },
    {
        columnId: ColumnID.PERCENT_TO_TARGET,
        order: SortOrder.ASC,
    },
];
